import { Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Store, select } from '@ngrx/store';
import * as RailroadLogoActions from './railroad-logo.actions';
import * as RailroadLogoSelectors from './railroad-logo.selectors';
import { RailroadDetailPartialState } from '../../+state/railroad-detail.reducer';
import { preventFlicker } from 'src/shared/utilities/custom-rxjs-operators';
@Component({
	selector: 'rpfsa-railroad-logo',
	templateUrl: './railroad-logo.component.html',
	styleUrls: ['./railroad-logo.component.scss'],
})
export class RailroadLogoComponent {
	readonly isLoading$ = this.store.pipe(
		select(RailroadLogoSelectors.getIsLoading),
		preventFlicker(1000)
	);

	readonly logo$ = this.store.pipe(
		select(RailroadLogoSelectors.getSelectedRailroadLogo),
		map((logo) => this.domSanitizer.bypassSecurityTrustUrl(logo))
	);

	readonly isDefaultLogo$ = this.store.pipe(
		select(RailroadLogoSelectors.getIsDefaultRailroadLogo)
	);

	constructor(
		private readonly store: Store<RailroadDetailPartialState>,
		private readonly domSanitizer: DomSanitizer
	) {}

	uploadLogo(event: { target: HTMLInputElement }) {
		this.store.dispatch(RailroadLogoActions.logoUploaded({ event }));
	}

	removeLogo() {
		this.store.dispatch(RailroadLogoActions.userClickedRemoveLogo());
	}
}
